export enum NpsStatusType {
  OK = 'OK',
  LATER = 'LATER',
}
export type CreateNpsBody = {
  status: NpsStatusType;
  score?: number;
  contactMe?: boolean;
  observation?: string;
};

export enum NpsViewType {
  ScoreForm = 'score-form',
  ContactForm = 'contact-form',
  ThanksMessage = 'thanks-message',
}

export type HandleAnswerScoreParams = {
  score: number;
};

export type HandleAnswerObservationParams = {
  contactMe: boolean;
  observation: string;
};

export type NpsContextProps = {
  isNpsOpen: boolean;
  isSubmitting: boolean;
  view: NpsViewType;
  npsValues: CreateNpsBody;
  handleAnswerLater: () => void;
  handleAnswerScore: ({ score }: HandleAnswerScoreParams) => void;
  handleAnswerJump: () => void;
  handleAnswerObservations: ({ contactMe, observation }: HandleAnswerObservationParams) => void;
  onClose: () => void;
};
